import React from 'react';
import { PropertyUiManagersListModel } from '../../../../../shared/ui-models/propertyManager.ui.model';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import PersonAddOutlinedIcon from '@material-ui/icons/PersonAddOutlined';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';

export interface ManagersListProps {
  data: {
    propertyManagersList: PropertyUiManagersListModel[];
  };
  eventHandlers: {
    deletePropertyManager: (id: string) => void;
    addPropertyManager: (show: boolean) => void;
  };
}

export const ManagersList: React.FC<ManagersListProps> = ({ data, eventHandlers }) => {
  const renderManagersTable = (managers: PropertyUiManagersListModel[]) => {
    return (
      <div className="w-full mt-4 bg-white border border-gray-100 rounded-xl shadow-sm overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-[15px] text-left">
            <thead className="text-lg text-gray-500 uppercase bg-gray-50 border-b border-gray-100">
              <tr>
                <th scope="col" className="px-6 py-4 font-semibold">
                  Name
                </th>
                <th scope="col" className="px-6 py-4 font-semibold">
                  Email
                </th>
                <th scope="col" className="px-6 py-4 font-semibold text-right">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100">
              {managers.map((user: PropertyUiManagersListModel) => (
                <tr key={user.id} className="hover:bg-gray-50/50 transition-colors duration-200">
                  <td className="px-6 py-4 font-medium text-gray-900">{user.name}</td>
                  <td className="px-6 py-4 text-gray-600">{user.email}</td>
                  <td className="px-6 py-4 text-right">
                    <button
                      type="button"
                      onClick={() => eventHandlers.deletePropertyManager(user.id)}
                      className="p-2 text-gray-400 hover:text-red-600 hover:bg-red-50 rounded-lg transition-all duration-200"
                      title="Remove Manager"
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  };

  return (
    <div className="flex flex-col w-full min-h-[300px]">
      <div className="flex justify-end mb-4">
        <button
          type="button"
          onClick={() => eventHandlers.addPropertyManager(true)}
          className="flex items-center gap-2 px-4 py-2 text-base font-medium text-primary-700 bg-primary-50 rounded-lg hover:bg-primary-100 transition-colors border border-primary-100"
        >
          <PersonAddOutlinedIcon fontSize="small" />
          Assign Property Manager
        </button>
      </div>

      {data?.propertyManagersList?.length > 0 ? (
        renderManagersTable(data.propertyManagersList)
      ) : (
        <div className="flex flex-col items-center justify-center py-16 px-4 text-center border-2 border-dashed border-gray-100 rounded-xl bg-gray-50/50 flex-grow mt-2">
          <div className="w-16 h-16 mb-4 rounded-full bg-green-50 flex items-center justify-center text-green-500">
            <CheckCircleOutlineIcon style={{ fontSize: 32 }} />
          </div>
          <h3 className="text-lg font-medium text-gray-900 mb-1">No Managers Assigned</h3>
          <p className="text-gray-500 max-w-sm">
            Everything looks Great! Assign a property manager when you are ready.
          </p>
        </div>
      )}
    </div>
  );
};
